import { action, observable } from "mobx";
import TourUpgradeRequestRepository from "~/repository/Tour/TourUpgradeRequestRepository";
import NestStore from "../NestStore";

class TourUpgradeRequestStore extends NestStore {
  tourUpgradeRequestRepository = null;

  /**
   * @property {Boolean} tourUpgradeRequestSent
   */
  @observable tourUpgradeRequestSent = false;

  constructor() {
    super();

    this.tourUpgradeRequestRepository = new TourUpgradeRequestRepository();
  }

  @action
  create(tourId, data) {
    this.isSaving = true;

    return this.tourUpgradeRequestRepository
      .create(tourId, data)
      .then(() => {
        this.tourUpgradeRequestSent = true;
      })
      .catch(error => {
        this.errorMessage = error.message;
        throw error;
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
}

export default TourUpgradeRequestStore;
